import styled from 'styled-components';

export const EmailContainer = styled.div`
  margin-top: 16px;
`;
